<template>
    <div class="not-found">
        <vue-headful :title="$t('not-found.meta-title')" :keywords="$t('not-found.meta-keywords')" :description="$t('not-found.meta-description')"/>

        <section class="hero">
            <div class="hero-body">
                <div class="container">
                    <!-- <h4 class="title is-size-4 has-text-centered is-unselectable">{{ $t('not-found.title') }}</h4> -->

                    <div class="columns is-centered is-mobile has-top-margin">
                        <div class="column">
                            <figure class="has-text-centered ">
                                <ResponsiveImage :src="require('@/assets/media/404/404.svg')" width="320px" height="320px" maxWidth="320px" maxHeight="320px"/>
                            </figure>
                        </div>
                    </div>

                    <div class="columns is-centered is-mobile has-bottom-margin">
                        <b-button tag="router-link" to="/" type="is-link" class="is-medium">{{ $t('not-found.subtitle') }}</b-button>
                    </div>

                </div>
            </div>
        </section>

    </div>
</template>

<script>
    import ResponsiveImage from "@/components/ResponsiveImage.vue";

    export default {
        components: {
            ResponsiveImage
        },
    };
</script>

<style lang="scss" scoped>
    div .has-top-margin {
        margin-top: 6rem;
    }

    div .has-bottom-margin {
        margin-bottom: 3rem;
    }

</style>